var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature col-lg-6"},[_c('div',{staticClass:"icon mr-2"},[_c('fa-icon',{attrs:{"icon":_vm.icon}})],1),_c('div',{staticClass:"px-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }